import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import firebase from 'firebase';
//
Vue.config.productionTip = false
window.axios = require('axios');
//
var firebaseConfig = {
  apiKey: "AIzaSyA84AlM8iXOZZTPDaAinzz-JtzN16StzKI",
  authDomain: "tutoriales-path.firebaseapp.com",
  projectId: "tutoriales-path",
  storageBucket: "tutoriales-path.appspot.com",
  messagingSenderId: "457459406538",
  appId: "1:457459406538:web:4cf31ad4535dc65b250633",
  measurementId: "G-YGSBC8JB85"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//
firebase.auth().onAuthStateChanged(function(user){
  new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
  }).$mount('#app')
})